<template>
  <div class="list">
    <div class="breadcrumb">
      <Breadcrumb>
        <Breadcrumb-item>学生管理</Breadcrumb-item>
        <Breadcrumb-item>打卡闯关记录</Breadcrumb-item>
      </Breadcrumb>
    </div>
    <div class="search" @keyup.enter="search">
      <Form :label-width="100" :show-message="false" label-position="right">
        <Row :gutter="32">
          <Col span="6">
            <Form-item label="类型">
              <Select v-model.number="queryParam.recordType" placeholder="全部" @on-change="search" clearable>
                <Option v-for="item in $constant.reviewClockRecordType"
                        :value="item.code" :key="item.code">{{ item.text }}</Option>
              </Select>
            </Form-item>
          </Col>
          <Col span="6">
            <Form-item label="学生ID">
              <Input name="uid" v-model="queryParam.uid"/>
            </Form-item>
          </Col>
          <Col span="6">
            <Form-item label="学导" >
              <admin-user-select :status="1" adminGroupCode="userStudyAdviser" v-model="queryParam.studyAdviserId"/>
            </Form-item>
          </Col>
          <Col span="6">
            <Form-item label="状态">
              <Select v-model.number="queryParam.status" placeholder="全部" @on-change="search" clearable>
                <Option v-for="item in $constant.reviewClockRecordStatus"
                        :value="item.code" :key="item.code">{{ item.text }}</Option>
              </Select>
            </Form-item>
          </Col>
          <Col span="8">
            <Form-item label="批改时间">
              <Row>
                <Col span="11">
                  <Date-picker type="datetime" format="yyyy-MM-dd HH:mm" placeholder="请选择日期"
                               v-model="queryParam.startUpdateTime" style="width: 100%;"/>
                </Col>
                <Col span="1" style="text-align: center">-</Col>
                <Col span="11">
                  <Date-picker type="datetime" format="yyyy-MM-dd HH:mm" placeholder="请选择日期"
                               v-model="queryParam.endUpdateTime" style="width: 100%;"/>
                </Col>
              </Row>
            </Form-item>
          </Col>
          <Col span="8">
            <Form-item label="打卡时间">
              <Row>
                <Col span="11">
                  <Date-picker type="datetime" format="yyyy-MM-dd HH:mm" placeholder="请选择日期"
                               v-model="queryParam.startTime" style="width: 100%;"/>
                </Col>
                <Col span="1" style="text-align: center">-</Col>
                <Col span="11">
                  <Date-picker type="datetime" format="yyyy-MM-dd HH:mm" placeholder="请选择日期"
                               v-model="queryParam.endTime" style="width: 100%;"/>
                </Col>
              </Row>
            </Form-item>
          </Col>
          <Col span="2">
            <Button type="primary" :loading="searchLoading" :disable="searchLoading" icon="search" @click="search" >搜索
            </Button>
          </Col>
        </Row>
      </Form>
    </div>
    <div class="btn-wrap">
      <Row>
        <Col>
<!--          <Button type="primary" :loading="searchLoading" :disable="searchLoading" @click="exportData" >导出
            </Button>-->
            <Button type="primary" :loading="searchLoading" :disable="searchLoading" @click="batchCheck" >批量批改
            </Button>
        </Col>
      </Row>
    </div>
    <List ref="dataList" :tableColumns="title" :reload="reload" listUrl="/study_record/pageList"
      :params="queryParam" :onLoading="onLoading" @on-selection-change="selectionChange"></List>
  </div>

</template>
<script>
  export default {
    components: {},
    data () {
      let $constant = this.$constant
      return {
        searchLoading: false,
        exportLoading: false,
        passLoading: false,
        reload: 0,
        uid: null,
        selectionIds: [],
        queryParam: {
          uid: null,
          status: null,
          studyAdviserId: null,
          startTime: null,
          endTime: null,
          startUpdateTime: null,
          endUpdateTime: null,
          recordType: null
        },
        title: [
          {
            type: 'selection',
            width: 60,
            align: 'center'
          },
          {
            title: '状态',
            width: 90,
            align: 'center',
            render: (h, params) => {
              let status = params.row.status
              let statusEnum = $constant.getEnum($constant.reviewClockRecordStatus, status)
              return h('span', statusEnum && statusEnum.text)
            }
          },
          {
            title: '类型',
            width: 80,
            align: 'center',
            key: 'recordType'
          },
          {
            title: '学生',
            width: 180,
            align: 'center',
            render: (h, params) => {
              let row = params.row
              return h('span', row.uid + '-' + row.nickname)
            }
          },
          {
            title: '学导',
            align: 'center',
            width: 180,
            render: (h, params) => {
              let row = params.row
              return h('span', row.studyAdviserId + '-' + row.studyAdviserName)
            }
          },
          {
            title: '课程名称',
            align: 'center',
            width: 150,
            key: 'lessonName'
          },
          {
            title: '打卡日期',
            align: 'center',
            width: 170,
            key: 'createdAt'
          },
          {
            title: '打卡时长(分)',
            align: 'center',
            width: 120,
            key: 'totalTimeStr'
          },
          {
            title: '闯关上传日期',
            align: 'center',
            width: 170,
            key: 'createdAt'
          },
          {
            title: '完成批改日期',
            align: 'center',
            width: 170,
            key: 'updatedAt'
          },
          {
            title: '闯关视频',
            align: 'center',
            width: 230,
            render: (h, params) => {
              let row = params.row
              return h('a', {on: {click: () => this.openVideoModal(row.videoUrl)}}, row.videoUrl)
            }
          },
          {
            title: '操作',
            align: 'center',
            width: 100,
            render: (h, params) => {
              let row = params.row
              let statusParam = row.status === 0 ? 1 : 0
              let text = statusParam === 1 ? '完成批改' : '撤销批改'
              return h('a', {on: {click: () => this.check(row.id, statusParam, text)}}, text)
            }
          }
        ]
      }
    },
    mounted: function () {
    },
    created: function () {
    },
    methods: {
      openVideoModal (val) {
        window.open(val, '_blank')
      },
      search () {
        this.selectionIds = []
        this.reload = new Date().getTime()
      },
      onLoading (loading) {
        this.searchLoading = loading
      },
      check (id, status, text) {
        let self = this
        self.$Modal.confirm({
          title: '温馨提示',
          content: '是否<span style="color: red">' + text + '</span>?',
          width: 300,
          okText: '确认',
          onOk: () => {
            self.$http.post('/study_record/check', {id: id, status: status}).then(function (res) {
              if (res) {
                self.search()
              }
            })
          }
        })
      },
      selectionChange (selection) {
        this.selectionIds = selection
      },
      batchCheck () {
        if (this.selectionIds.length <= 0) {
          this.$Message.warning('请选择需批改的记录！')
          return
        }
        let self = this
        let idList = self.selectionIds.map(function (element) {
          return element.id
        })
        self.$Modal.confirm({
          title: '温馨提示',
          content: '是否<span style="color: red">批量完成批改</span>?',
          width: 300,
          okText: '确认',
          onOk: () => {
            self.$http.post('/study_record/batchCheck', {ids: idList, status: 1}).then(function (res) {
              if (res) {
                self.search()
              }
            })
          }
        })
      },
      exportData () {
        this.exportLoading = true
        this.$http.get('/study_record/export', {responseType: 'arraybuffer', params: this.queryParam}).then((response) => {
          if (response.data) {
            let blob = new Blob([response.data], {type: 'text/csv'})
            let link = document.createElement('a')
            link.target = '_blank'
            link.href = window.URL.createObjectURL(blob)
            link.download = '打卡闯关列表.xlsx'
            link.click()
            this.exportLoading = false
          } else {
            this.$Message.error(response.msg)
          }
        }).catch((e) => {
          this.exportLoading = false
        })
      }
    }
  }

</script>
<style lang="less" scoped>
  .btn-wrap {
    text-align: right;
    margin-top: 24px;
    margin-bottom: 12px;
  }
</style>



// WEBPACK FOOTER //
// ReviewClockRecordList.vue?31cef6a7